import angular from 'angular';
import quickItemDialogTemplate from './quickItemDialog.html';


/*******************************************************************************
 * @ngdoc component
 * @name  csm.books.MakeDeposit.component:quickItemDialog
 * @param {Object=} itemInfo    Item information.
 * @param {Expr}    saveAction  Action for save button.
 * @description
 * Quick deposit item input dialog. `itemInfo` is empty for new item. `saveAction`
 * is called with `$orig` as `itemInfo` passed in and `$info` is info to save.
 * Both values are returned so the original item can be found in ui-grid.
 *******************************************************************************/
/* @ngInject */ export function quickItemDialogDirective(ClickDialogDirective) {
  return new ClickDialogDirective({
    template: quickItemDialogTemplate,
    scope: { itemInfo: '<?', saveAction: '&', lockChanges: '<' },
    size: 'md',
    controller: controller
  });

  /* @ngInject */ function controller(
    $scope,
    $uibModalInstance,
    Data,
    Globals,
    SERVER
  ) {
    /** Self reference. */ var $ctrl = this;
    $ctrl.validators = {};
    $ctrl.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
    $ctrl.accountLabel = SERVER.BooksWebConstants.accountLabel;

    /*-------------------------------------------*/
    /* Populate account selector data providers. */
    /*-------------------------------------------*/
    $ctrl.dpRevenueAccounts = Globals.accounts.revenue;

    /*----------------------------------------*/
    /* Create a new object from the original. */
    /*----------------------------------------*/
    var origInfo = $ctrl.itemInfo;
    $ctrl.isNew = !origInfo;
    $ctrl.itemInfo = new Data.QuickDepositItem(origInfo);

    /*--------------------------------*/
    /* Set the account object on the  */
    /* `itemInfo` if this is not new. */
    /*--------------------------------*/
    if (!$ctrl.isNew) {
      $ctrl.dpRevenueAccounts.some(function (account) {
        if (
          account.accountID ==
          origInfo.saleItemTotals[0].accountInfo.accountID
        ) {
          $ctrl.itemInfo.account = account;
          return true;
        }
      });
    }

    /*-----------------------------------------------------------------*/
    /* Save handler calls `saveAction` with `$oldInfo` and `$newInfo`. */
    /*-----------------------------------------------------------------*/
    $ctrl.save = function () {
      if (!$ctrl.validators.validate()) return;
      $ctrl.validators.reset();

      angular.extend($ctrl.itemInfo.saleItem, $ctrl.itemInfo.accountObj);
      $ctrl
        .saveAction({ $orig: origInfo, $item: $ctrl.itemInfo })
        .then(function () {
          $uibModalInstance.close();
        });
    };
  }
};
